export const DELIVERY_VALIDATION_TYPES = {
	RADIUS: 'RADIUS',
	ZONE: 'ZONE',
} as const

export type DeliveryValidationType =
	(typeof DELIVERY_VALIDATION_TYPES)[keyof typeof DELIVERY_VALIDATION_TYPES]

const SUPPORTED_DELIVERY_VALIDATION_TYPES = Object.values(
	DELIVERY_VALIDATION_TYPES,
) as readonly DeliveryValidationType[]

export function isSupportedValidationType(
	type: string | undefined | null,
): type is DeliveryValidationType {
	return SUPPORTED_DELIVERY_VALIDATION_TYPES.includes(type as DeliveryValidationType)
}
